import { FC, ReactElement } from 'react';
import { NavLink as BaseLink } from 'react-router-dom';

import { Box, rem, Show, StyleProps } from '@bonusly/design-system';

import { useIsRecognize } from '../../hooks/useIsRecognize';

interface Props extends StyleProps {
	children: string;
	icon: ReactElement;
	isActive?: boolean;
	to: string;
	onTrack?: VoidFunction;
	id?: string;
	onClick?: VoidFunction;
}

export const NavLink: FC<Props> = ({ children, icon, onTrack, to, id, onClick, isActive: customIsActive, ...rest }) => {
	const isRecognize = useIsRecognize();
	const isRecognizeActive =
		isRecognize && (window.location.href === to || (window.location.href?.endsWith('/company/rewards/my_rewards') && to?.endsWith('/rewards')));

	return (
		<Box as="li" onClick={onTrack && onClick} id={id}>
			<BaseLink reloadDocument={isRecognize} to={to} data-testid="nav-link">
				{({ isActive }) => {
					const isLinkActive = isActive || isRecognizeActive || customIsActive;

					return (
						<Box
							alignItems="center"
							aria-label={children}
							as="span"
							backgroundColor={isLinkActive ? 'blueAlpha.100' : 'none'}
							borderRadius="md"
							color={isLinkActive ? 'blue.800' : 'gray.700'}
							display="inline-flex"
							fontSize={{ base: '2xl', sm: 'lg ' }}
							fontWeight={465}
							h={rem(44)}
							justifyContent="center"
							px={{ base: 1, sm: 3 }}
							w={{ base: rem(44), sm: 'auto' }}
							whiteSpace="nowrap"
							_hover={{
								textDecor: 'none',
							}}
							{...rest}
						>
							<Show above="sm">{children}</Show>
							<Show below="sm">{icon}</Show>
						</Box>
					);
				}}
			</BaseLink>
		</Box>
	);
};
